module.exports = __webpack_public_path__ + "img/tetosPraxisFiltro.6aeff172.webp";